export {}

declare global {
    interface Window {
        fakturaId:string;
        supplierId?: number;
        userId: number;
        apiUrl: string;
        JSRpcPlaner: any;
        KonteringsOptions: object,
        InvoicePageState: object,
        $: any;
        klientId?: number;
    }
  }
  
  export default {
      fakturaId: window.fakturaId,
      supplierId: window.supplierId || 0,
      userId: window.userId,
      apiUrl: window.apiUrl,
      klientId: window.klientId,
  }